import clsx from 'clsx';
import React from 'react';

/**
 * Definition-list rows used by every V2 record view.
 * - Fact: one cell of the facts strip under a record title (label over value).
 * - Row: a details row (132px label column) — reading first, editing second.
 * - RailRow: the narrower variant (84px label) for the right-hand rail.
 */
export const Fact: React.FC<{
  label: string;
  value?: React.ReactNode;
  sub?: React.ReactNode;
  missing?: boolean;
}> = ({ label, value, sub, missing }) => (
  <div className="min-w-0">
    <dt className="text-v2-11 font-medium text-v2-fg-3">{label}</dt>
    <dd
      className={clsx(
        'mt-0.5 truncate text-v2-14 font-medium',
        missing ? 'text-v2-fg-4' : 'text-v2-fg',
      )}
    >
      {value ?? '—'}
      {sub && (
        <span className="ml-1.5 text-v2-12 font-normal text-v2-fg-3">
          {sub}
        </span>
      )}
    </dd>
  </div>
);

export const Row: React.FC<{
  label: string;
  children?: React.ReactNode;
  empty?: boolean;
}> = ({ label, children, empty }) => (
  <div className="grid grid-cols-[132px_minmax(0,1fr)] gap-x-4 border-b border-v2-line/70 py-2 last:border-b-0">
    <dt className="text-v2-12 text-v2-fg-3">{label}</dt>
    <dd
      className={clsx(
        'min-w-0 text-v2-13',
        empty ? 'text-v2-fg-4' : 'text-v2-fg',
      )}
    >
      {children ?? '—'}
    </dd>
  </div>
);

export const RailRow: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <div className="grid grid-cols-[84px_minmax(0,1fr)] gap-x-3 border-b border-v2-line/70 py-1.5 text-v2-12 last:border-b-0">
    <dt className="text-v2-fg-3">{label}</dt>
    <dd className="min-w-0 truncate text-v2-fg">{children}</dd>
  </div>
);
